import styles from './MontpellierIAConnect.module.css'

const MontpellierIAConnect = () => (
  <>
    <header className={styles.header}>
      <div className={styles.contentContainer}></div>
    </header>
  </>
)

export default MontpellierIAConnect
